<template>
  <div class="ticket">
    <div class="right-container" />
    <div class="left-container">
      <canvas ref="qrcode" class="qrcode" :style="{ margin: 0, padding: 0 }" />
      <div class="jir-and-zki">
        JIR: {{ fiscalisationInfo.jir }}<br>
        ZKI: {{ fiscalisationInfo.zki }}
      </div>
      <div class="vat-info">
        <strong>KK Cibona Zagreb</strong><br>
        Organizator je u sustavu PDV-a prema čl. 90, st. 1 i 2 Zakona o PDV-u. Ulaznica vrijedi kao
        račun.
      </div>
      <div class="invoice-data-container">
        <div class="not-ticket-text">Ovo nije ulaznica, ovo je račun.</div>
        <div class="invoice-data">
          <p>Način plaćanja: {{ paymentMethodLabel }}</p>
          <p>
            Račun broj: <strong>{{ getInvoiceNumber() }}</strong>
          </p>
          <p>Izdan: {{ getPublishedTime() }}</p>
          <p>Izdao: <strong>Cibona Fan Shop</strong> j.d.o.o.,</p>
          <p>Adresa: Savska cesta 30, 10000, Zagreb</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import moment from 'moment-timezone'
import { round } from 'lodash'
import { convertUtcToCroatianLocalTime } from '@/utils'
import { invoicePaymentMethodLabel } from '@/utils/fiscal-payment-method'

export default {
  name: 'kk-cibona-ticket-seller-invoice-pdf',
  props: {
    eventInfo: Object,
    organization: Object,
    ticketInfo: Object,
    index: Number,
    ticketCount: Number,
    fiscalisationInfo: Object,
    order: Object,
  },
  data() {
    return {
      totalPriceRounded: null,
    }
  },
  computed: {
    paymentMethodLabel() {
      return invoicePaymentMethodLabel(this.order, this.fiscalisationInfo)
    },
  },
  async mounted() {
    this.generateQrCode(this.fiscalisationInfo)
    this.loading = false
  },
  methods: {
    round,
    async generateQrCode(data) {
      const canvas = this.$refs.qrcode
      const publishTime = this.buildPublishTime(data, this.order.createdAt)

      return QRCode.toDataURL(
        canvas,
        `https://porezna.gov.hr/rn?jir=${data.jir}&datv=${publishTime}&izn=${data.totalPrice}`,
        {
          width: 80,
          margin: 0,
        },
      )
    },
    getInvoiceNumber() {
      if (this.fiscalisationInfo && this.fiscalisationInfo.full_receipt && this.fiscalisationInfo.full_receipt.designation) {
        const designation = this.fiscalisationInfo.full_receipt.designation
        if (designation.number && designation.location_id && designation.register_number) {
          return `${designation.number}-${designation.register_number}-${designation.location_id}`
        }
      }

      return `${this.order.invoiceNumber}-1-${
        moment(this.getPublishedTime, 'DD.MM.YYYY hh:mm').isAfter('2024/2/26 23:59') ? 12 : 10
      }`
    },
    getPublishedTime() {
      return moment(this.order.createdAt).format('DD.MM.YYYY HH:mm')
    },
    buildPublishTime(data, createdAt) {
      if (data && data.publishTime) {
        return convertUtcToCroatianLocalTime(data.publishTime, 'YYYYMMDD_HHmm')
      }
      if (data && data.full_receipt && data.full_receipt.issue_date_time) {
        return moment
          .unix(data.full_receipt.issue_date_time)
          .tz('Europe/Zagreb')
          .format('YYYYMMDD_HHmm')
      }

      return convertUtcToCroatianLocalTime(
        moment(createdAt).format('YYYYMMDD_HHmm'),
        'YYYYMMDD_HHmm',
      )
    },
  },
}
</script>

<style scoped>
.application--wrap {
  min-height: fit-content !important;
}

.ticket {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 80mm;
  height: 210mm;
  overflow: hidden;
  box-sizing: border-box;
  page-break-before: always;
}

.right-container {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
  transform: rotate(-90deg) translateX(-53.97mm);
  width: 53.97mm;
  height: 80mm;
}

p,
h1 {
  margin-bottom: 0;
}

.left-container {
  position: absolute;
  top: 80mm;
  left: 0;
  transform-origin: top left;
  transform: rotate(-90deg) translateX(-130mm);
  width: 156.03mm;
  height: 80mm;
  padding: 37.88mm 3.45mm 5.34mm 8.74mm;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 9.46mm;
}

.qrcode {
  position: absolute;
  bottom: 5.34mm;
  left: 8.74mm;
}

.jir-and-zki {
  position: absolute;
  bottom: 5.34mm;
  left: 34.06mm;

  color: black;
  font-size: 8.4px;
  font-family: Open Sans;
  font-weight: 400;
  word-wrap: break-word;
}

.vat-info {
  width: 35.43mm;

  color: black;
  font-size: 8.4px;
  font-family: Open Sans;
  font-weight: 400;
  word-wrap: break-word;
}

.invoice-data {
  color: black;
  font-size: 8.5px;
  font-family: Open Sans;
  font-weight: 400;
  word-wrap: break-word;
}

.not-ticket-text {
  color: black;
  font-size: 16.8px;
  font-family: Open Sans;
  font-weight: 800;
  word-wrap: break-word;
  margin-bottom: 15px;
}
.invoice-data-container {
  max-width: 44.55mm;
}
</style>
